import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack, Tabs, Tab } from '@mui/material';

import Scrollbar from '../../../../../components/Scrollbar';
import { BonusForm } from './BonusForm';
import Iconify from '../../../../../components/Iconify';
import { useSelector } from 'react-redux';

export const FullScreenView = props => {
  const { data, submitCallback, handleClose, allSeasons, allResorts, allAgeRanges, allCamps } = props;
  const { module } = useSelector(state => state.app);
  const [currentTab, setCurrentTab] = React.useState(0);

  return (
    <Scrollbar>
      { currentTab === 0
        ? <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1} mr={2}>
          <Stack flex="1 1 70%">
            <Card>
              <CardHeader title={data ? 'Edytuj bonus' : 'Dodaj bonus'} sx={{ mt: -1, mb: -2 }} />
              <CardContent>
                <BonusForm
                  data={data}
                  submitCallback={submitCallback}
                  handleClose={handleClose}
                />
              </CardContent>
            </Card>
          </Stack>
        </Box>
        : <Box>asd</Box>}
    </Scrollbar>
  );
};
